"use strict";
exports.__esModule = true;
exports.useInitializeContext = exports.usePaginationContext = exports.PaginationContext = void 0;
var react_1 = require("react");
exports.PaginationContext = react_1.createContext(undefined);
var usePaginationContext = function () {
    var context = react_1.useContext(exports.PaginationContext);
    if (!context) {
        throw new Error('usePaginationContext must be inside a Pagination');
    }
    return context;
};
exports.usePaginationContext = usePaginationContext;
var usePageLimitRange = function (_a) {
    var page = _a.page, pageMin = _a.pageMin, pageMax = _a.pageMax, pageLimit = _a.pageLimit;
    var _b = react_1.useState(pageMin), pageStartFromState = _b[0], setPageStart = _b[1];
    var _c = react_1.useState(Math.min(pageMax, pageMin + pageLimit - 1)), pageEndFromState = _c[0], setPageEnd = _c[1];
    var valueMin = Math.max(page - 1, pageMin);
    var valueMax = Math.min(page + 1, pageMax);
    if (valueMin < pageStartFromState) {
        setPageStart(valueMin);
        setPageEnd(Math.min(valueMin + pageLimit - 1, pageMax));
    }
    else if (valueMax > pageEndFromState) {
        setPageStart(Math.max(valueMax - pageLimit + 1, pageMin));
        setPageEnd(valueMax);
    }
    return {
        pageStart: pageStartFromState,
        pageEnd: pageEndFromState
    };
};
var useInitializeContext = function (_a) {
    var page = _a.page, onChange = _a.onChange, pageMin = _a.pageMin, pageMax = _a.pageMax, pageLimit = _a.pageLimit;
    var _b = react_1.useState(page), pageFromState = _b[0], setPage = _b[1];
    var _c = usePageLimitRange({
        page: pageFromState,
        pageMin: pageMin,
        pageMax: pageMax,
        pageLimit: pageLimit
    }), pageStart = _c.pageStart, pageEnd = _c.pageEnd;
    react_1.useEffect(function () {
        setPage(page);
    }, [page, setPage]);
    var changePage = function (value) {
        setPage(value);
        if (onChange) {
            onChange(value);
        }
    };
    return {
        pageMin: pageMin,
        pageMax: pageMax,
        pageStart: pageStart,
        pageEnd: pageEnd,
        page: pageFromState,
        changePage: changePage
    };
};
exports.useInitializeContext = useInitializeContext;
//# sourceMappingURL=PaginationContext.js.map